import swal from "sweetalert";

$('#change_contract').change(function () {
   swal({
      text: "Espere un momento",
      icon: imageURL,
      button: false,
   });
   if($(this).val() == 'new')
   {
      location.href = https + 'client/contract/'+$(this).attr('id_client');
   }else{
      location.href = https + 'client/change_contract/'+$(this).val();
   }
});

$('.container-service-client .btn-observations-fee').click(function () {
   if($(this).attr('validate') == '1'){
      $(this).attr('validate','2');
      if(this.id == 1000){
         $(this).html('Actualizar');
      }else{
         $(this).html('Editar Observaciones');
      }
      $('.container-service-client .element-observation-'+this.id).css('display','none');
      $('.container-service-client .observation-'+this.id).css('display','block');
   }else{
      swal({
         text: "Espere un momento",
         icon: imageURL,
         button: false,
      });
      $.ajax({
         type: "post",
         url: https + "edit_service_client/observation",
         data: {
            id: this.id,
            observations: $('#observation_'+this.id).val(),
         },
         success: function (data) {
            if ($.trim(data) == "1") {
               location.reload();
            } else {
               swal({
                  text: "Error, ha ocurrido un problema",
                  icon: imageURL,
                  button: "OK!",
               });
            }
         }
      });
   }
});

var elementsForm,contLogin;

$('#formUpdateClient .btnUpdateClient').click(function () {
   $('#formUpdateClient').submit();
});

$("#formUpdateClient").on('submit', function (e) {
   e.preventDefault();
   elementsForm = [
      /*
      "name",
      "nit",
      "web",
      "web_status",
      "address",
      "city",
      "phone",
      "mail",
      "sector",
      "name_aut",
      "cc_aut",
      "position_aut",
      "mail_aut",
      "phone_aut",
      */
   ];
   contLogin = validationForm(elementsForm,contLogin = 1);

   if(contLogin == 0)
   {
      swal({
         text: "Debes completar todos los datos",
         icon: imageURL,
         button: "OK!",
      });
      return false;
   }

   swal({
      text: "Espere un momento",
      icon: imageURL,
      button: false,
   });
   var data = $(this).serialize();
   $.ajax({
      url: https + "updateClient",
      method: "POST",
      data: data,
      success: function (data) {
         if ($.trim(data) == "1") {
            location.href = https + 'client/'+$('#id_client').val();
         }else if($.trim(data) == "2") {
            swal({
               text: "No tiene los permisos necesarios",
               icon: imageURL,
               button: "OK!",
            });
         }else {
            swal({
               text: "Error, hubo problemas",
               icon: imageURL,
               button: "OK!",
            });
         }
      }
   });
});

function validationForm(elementsForm,contLogin)
{
   for(var i=0;i<elementsForm.length;i++){

      $('#'+elementsForm[i]).removeClass('error');

      if ( $.trim($("#"+elementsForm[i]).val()) == "" ) {
         contLogin = 0;
         $('#'+elementsForm[i]).addClass('error');
      }

   }

   return contLogin;
}

